const search = typeof window !== 'undefined' ? window?.location?.search : ''
const urlParams = new URLSearchParams(search)

export const isNewPDP = urlParams?.get('pdp') === 'new'
